<template>
  <div class="view-exercises">
    <list-layout>
      <filters :filters="filters" @filter="setFilter" v-if="filtersVisible"></filters>
      <ul>
        <list-item size="small" v-for="e in filteredExercises" :index="$index" :order="e.order" :link="getListItemLink(e.id)">
          {{e.title}}
        </list-item>
      </ul>
    </list-layout>
  </div>
</template>

<script>
import view from '../mixins/view'
import exercises from '../mixins/exercises'

import Exercise from '../components/Exercise.vue'
import ListLayout from '../layouts/List.vue'
import ListItem from '../components/ListItem.vue'
import Filters from 'components/Filters'
import Container from 'components/Container'

import { updateIndex } from '../vuex/exercises/actions'
import { role } from 'state/auth/getters'

export default {
  name: 'ExercisesView',
  mixins: [view, exercises],
  components: {
    Exercise,
    ListLayout,
    ListItem,
    Filters,
    Container
  },
  data () {
    return {
      title: 'Liste over øvelser',
      options: {
        onUpdate: this.onUpdate,
        animation: 150
      }
    }
  },
  vuex: {
    actions: {
      updateIndex
    },
    getters: {
      role
    }
  },
  methods: {
    getListItemLink (id) {
      return {
        name: 'exercise',
        params: {
          id: id
        }
      }
    },
    onUpdate (e) {
      this.updateIndex(e.oldIndex, e.newIndex)
    }
  },
  computed: {
    filtersVisible() {
      return this.role !== 'facilitator'
    }
  }
}
</script>

<style lang="scss" scoped>
  .view-exercises {
    min-height: 100%;
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// ExercisesView.vue?6ec2a2aa